// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__15AUG","modalFooterButton":"ModalNotes_modalFooterButton__CZWlx"};